/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-21 23:50:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-05 11:07:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/hooks/customHooks.tsx
 */
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
//import { instanceType, AllTypes } from 'src/tools/helper';
const switchUuidHooks = ({ getUuid, url }) => {
  const _h = useHistory();

  const _d: any = useSelector(getUuid());
  const { uuid } = _d;

  const _params = useParams();
  useAfterDidMountEffect(() => {
    if (uuid !== _params['uuid']) {
      if (!uuid) {
        _h.push({
          pathname: `${url}/new`,
          state: {
            skipNotice: true,
          },
        });
      } else {
        _h.push({
          pathname: `${url}/${uuid}`,
          state: {
            skipNotice: true,
          },
        });
      }

      // _h.push(`${url}/${uuid}`);
    }
  }, [uuid]);
};
export { switchUuidHooks };
